import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export function createStore(roomId) {

  const modules = {};

  [
    'room',
    'local',
    'memo',
    'characters',
    'messages',
    'characterList',
    'scenes',
    'items',
    'itemList',
    'images',
    'imageObjectList',
    'sounds',
    'controllers',
    'selectors',
    'members'
  ].forEach(name => {
    modules[name] = require(`./modules/${name}`).default
  })

  const store = new Vuex.Store({
    plugins: [function (store) { console.log(store); }],
    modules: {
      ...modules
    }
  })

  store.dispatch('images/$connect', 'rooms/' + roomId)
  store.dispatch('sounds/$connect', 'rooms/' + roomId)
  store.dispatch('room/$connect', 'rooms/' + roomId)
  store.dispatch('characters/$connect', 'rooms/' + roomId)
  store.dispatch('characterList/$connect', 'rooms/' + roomId)
  store.dispatch('imageObjectList/$connect', 'rooms/' + roomId)
  store.dispatch('messages/$connect', 'rooms/' + roomId)
  store.dispatch('scenes/$connect', 'rooms/' + roomId)
  store.dispatch('items/$connect', 'rooms/' + roomId)
  store.dispatch('itemList/$connect', 'rooms/' + roomId)
  store.dispatch('members/$connect', 'rooms/' + roomId)

  store.subscribeAction((action) => {
    if (!window.gtag) return
    gtag('event', action.type)
  })

  return store
}
